import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { fr } from "../content/fr";
import { submitLead } from "../lib/api";
import { track } from "../lib/tracking";
import { Reveal } from "./ui-bits";

const empty = { nom: "", email: "", entreprise: "", profil: "ecommerce", message: "" };

export default function QualificationForm() {
  const [form, setForm] = useState(empty);
  const [status, setStatus] = useState(null);
  const f = fr.qualification.fields;
  const update = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try { await submitLead(form); track("Lead", { email: form.email }); setStatus("ok"); setForm(empty); }
    catch { setStatus("err"); }
  };

  return (
    <section className="section section--soft" id="postuler" data-testid="qualification-section">
      <div className="container page-narrow">
        <Reveal className="block-head center">
          <span className="eyebrow" style={{ justifyContent: "center" }}><span className="sq" />{fr.qualification.eyebrow}</span>
          <h2 className="h2">{fr.qualification.title}</h2>
          <p className="lead center" style={{ marginTop: "1rem" }}>{fr.qualification.subtitle}</p>
        </Reveal>
        <form className="glass card" onSubmit={onSubmit} data-testid="qualification-form">
          <div className="form-grid">
            <div className="field"><label htmlFor="q-nom">{f.nom}</label><input id="q-nom" required value={form.nom} onChange={update("nom")} data-testid="q-nom" /></div>
            <div className="field"><label htmlFor="q-email">{f.email}</label><input id="q-email" type="email" required value={form.email} onChange={update("email")} data-testid="q-email" /></div>
            <div className="field"><label htmlFor="q-entreprise">{f.entreprise}</label><input id="q-entreprise" value={form.entreprise} onChange={update("entreprise")} data-testid="q-entreprise" /></div>
            <div className="field"><label htmlFor="q-profil">{f.profil}</label>
              <select id="q-profil" value={form.profil} onChange={update("profil")} data-testid="q-profil">
                {fr.qualification.profils.map((p) => <option key={p.v} value={p.v}>{p.l}</option>)}
              </select>
            </div>
            <div className="field full"><label htmlFor="q-message">{f.message}</label><textarea id="q-message" rows={4} value={form.message} onChange={update("message")} data-testid="q-message" /></div>
          </div>
          <div style={{ marginTop: "1.4rem", display: "flex", alignItems: "center", gap: "1rem", flexWrap: "wrap" }}>
            <button type="submit" className="btn btn--primary" disabled={status === "loading"} data-testid="funnel-submit-btn">
              {status === "loading" ? "Envoi…" : fr.qualification.submit} <ArrowRight size={16} />
            </button>
            {status === "ok" && <span className="form-status ok" data-testid="form-success">{fr.qualification.success}</span>}
            {status === "err" && <span className="form-status err" data-testid="form-error">{fr.qualification.error}</span>}
          </div>
        </form>
      </div>
    </section>
  );
}
